import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class PlatonPoints extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.platonPointsShow(id)}>{value}</Link>,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
        ];
    }

    renderCreateButton = () => {
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.platonPointsNew,
        };
        return <Link {...props}>Добавить рамку Платон</Link>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(PlatonPoints, "platon-points");
